import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";

const initialState = {
  token: null,
  userName: "",
  error: null,
  message: "",
  isLoading: false,
  errorMsg: "",
  userId: null,
  imageUrl: "",
  bio: "",
  phone: "",
  city: "",
  country: "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return updateObject(state, {
        isLoading: true,
      });
    case actionTypes.AUTH_ERROR:
      return updateObject(state, {
        isLoading: false,
        errorMsg: action.errorMsg,
      });
    case actionTypes.AUTH_SUCCESS:
      return updateObject(state, {
        isLoading: false,
        message: action.message,
      });
    case actionTypes.AUTH_LOGOUT:
      return updateObject(state, {
        token: null,
        userName: "",
        userId: null,
        imageUrl: "",
        isLoading: false,
        bio: "",
        phone: "",
        city: "",
        country: "",
      });
    case actionTypes.AUTH_ACTIVATION_SUCCESS:
      return updateObject(state, {
        isLoading: false,
        message: action.message,
        userName: action.userName,
      });
    case actionTypes.AUTH_SIGNIN_SUCCESS:
      return updateObject(state, {
        isLoading: false,
        userName: action.userName,
        userId: action.userId,
        token: action.token,
        imageUrl: action.imageUrl,
        bio: action.bio,
        phone: action.phone,
        city: action.city,
        country: action.country,
      });
    default:
      return state;
  }
};

export default authReducer;
